export class Kontaktdaten {
    name = ""
    email = ""
    telefon = ""

    toJSON() {
        return {
            name: this.name,
            email: this.email,
            telefon: this.telefon,
        }
    }
}
